import { Separator } from "@/components/ui/Separator"

import { BasicInformationForm } from "./components/StudentBasicInformation"
import { UpdatePasswordForm } from "./components/UpdatePassword"
import { DeleteAccountButton } from "./components/DeleteAccountButton"

import { StudentProfileController } from "./StudentProfile.controller"

export type DeleteClick = "delete" | "email-support"

interface StudentProfileProps {
  controller: StudentProfileController
}

export function StudentProfile({ controller }: StudentProfileProps) {
  async function handleDeleteClick(): Promise<DeleteClick | void> {
    const user = controller.user
    if (!user) return

    if (controller.isTeacher) {
      return "delete"
    }

    try {
      const result = await Promise.resolve(controller.deleteAccountDialog(user))
      return result
    } catch (error) {
      console.error("Failed to check assignments:", error)
    }
  }

  async function handleConfirmDelete(deleteReason: string): Promise<void> {
    await controller.deleteAccountAndSignOut(deleteReason)
  }

  return (
    <div className="tw-container tw-p-2">
      <h1 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-text-center">
        Student Profile
      </h1>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-2" />

      <div className="tw-px-5">
        <BasicInformationForm user={controller.user} />
      </div>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-10" />

      <div className="tw-px-5">
        <UpdatePasswordForm />
      </div>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-10" />

      <div className="tw-px-5">
        <DeleteAccountButton
          deleteOptions={controller.getDeleteOptions()}
          errorMessage={controller.errorMessage}
          onDeleteClick={handleDeleteClick}
          onConfirmDelete={handleConfirmDelete}
        />
      </div>
    </div>
  )
}
